module.exports = __webpack_public_path__ + "static/media/Q6_figure.185b2b4f.png";